import Login from '../views/Login';
import LoginLayout from '../Layouts/LoginLayout';
import ForgotPassword from '../views/ForgotPassword';
import CheckoutForm from '../views/Checkout/CheckoutForm';
import CheckoutLayout from '../Layouts/CheckoutLayout';
import CheckoutFinish from "../views/Checkout/CheckoutFinish";

const guestRoutes = [
  {
    path: '/',
    name: 'Main',
    component: Login,
    meta: {
      layout: LoginLayout,
      role: 'guest',
      title: 'Login'
    }
  },
  {
    path: '/forgot-password/:userid',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      layout: LoginLayout,
      role: 'guest',
      title: 'Forgot Password'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      layout: LoginLayout,
      role: 'guest',
      title: 'Login'
    }
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: CheckoutForm,
    meta: {
      layout: CheckoutLayout,
      role: 'guest',
      title: 'GOFAR Checkout'
    }
  },
  {
    path: '/checkout-finish',
    name: 'CheckoutFinish',
    component: CheckoutFinish,
    meta: {
      layout: CheckoutLayout,
      role: 'guest',
      title: 'GOFAR Checkout Success'
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
];

export default guestRoutes;
